"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class WebModal extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.modal = (0, _react.createRef)();
    this.wrap = (0, _react.createRef)();
    this.content = (0, _react.createRef)();
  }
  componentDidMount() {
    this.handleZIndex();
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  }
  handleZIndex() {
    if (this.props.classZIndex) {
      document.querySelector(this.props.classZIndex).classList[this.state.close ? 'remove' : 'add']('modal__zindex');
    }
  }
  handleClose() {
    this.setState({
      close: true
    }, () => this.modal.current.addEventListener('animationend', () => {
      if (this.props.onClose) {
        this.props.onClose();
      } else {
        const {
          _reactInternalFiber: internal
        } = this;
        const {
          _debugOwner: parent
        } = internal;
        if (parent) {
          parent.stateNode.setState({
            [this.props.stateToggle || 'modal']: false
          });
        }
      }
      this.handleZIndex();
    }));
  }
  handleScrollEnter() {
    if (this.props.size != 'full-screen') {
      const {
        current
      } = this.content;
      const {
        offsetHeight
      } = current;
      const {
        scrollHeight
      } = current;
      current.classList[offsetHeight === scrollHeight ? 'add' : 'remove']('modal__content--noscroll');
    }
  }
  handleScrollLeave() {
    const {
      current
    } = this.content;
    current.classList.remove('modal__content--noscroll');
  }
  render() {
    return _react.default.createElement("div", {
      ref: this.modal,
      className: "modal ".concat(this.state.close ? 'modal--close' : '')
    }, _react.default.createElement("div", {
      "aria-hidden": "true",
      className: "modal__bg",
      onClick: () => this.handleClose()
    }), _react.default.createElement("div", {
      className: "modal__box ".concat(this.props.size ? "modal__box--".concat(this.props.size) : '')
    }, this.props.icon && _react.default.createElement("div", {
      className: "ta-c"
    }, _react.default.createElement(_img.default, {
      className: "modal__icon",
      src: this.props.icon
    })), this.props.title && _react.default.createElement("h2", {
      className: "modal__bigtitle ta-c"
    }, this.props.title), _react.default.createElement("div", {
      "aria-hidden": "true",
      className: "modal__close",
      onClick: () => this.handleClose()
    }, _react.default.createElement(_img.default, {
      src: "/assets/img/icons/times.svg"
    })), this.props.children && _react.default.createElement("div", {
      className: "modal__wrap ".concat(this.props.shadow ? 'modal__wrap--shadow' : '')
    }, _react.default.createElement("div", {
      className: "modal__content".concat(this.props.size != 'full-screen' && '--full-screen'),
      ref: this.content,
      onMouseEnter: () => this.handleScrollEnter(),
      onMouseLeave: () => this.handleScrollLeave()
    }, this.props.children)), this.props.button && _react.default.createElement("div", {
      className: "modal__buttons"
    }, this.props.button)));
  }
}
var _default = exports.default = WebModal;